import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DsIconModule, DsModalModule, DsTooltipModule } from '@levelaccess/design-system';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../shared/shared.module';
import { VerticalNavigationComponent } from './vertical-navigation.component';
import { VerticalNavigationPanelComponent } from './vertical-navigation-panel/vertical-navigation-panel.component';
import { VerticalNavigationModalComponent } from './vertical-navigation-modal/vertical-navigation-modal.component';
import { NavigationContextSwitcherComponent } from './navigation-context-switcher/navigation-context-switcher.component';
import { VerticalMenuComponent } from './vertical-menu/vertical-menu.component';

@NgModule({
  declarations: [
    VerticalNavigationComponent,
    VerticalNavigationPanelComponent,
    VerticalNavigationModalComponent,
    VerticalMenuComponent,
  ],
  exports: [
    VerticalNavigationComponent,
    VerticalNavigationPanelComponent,
    VerticalNavigationModalComponent,
    VerticalMenuComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    DsIconModule,
    DsTooltipModule,
    DsModalModule,
    NavigationContextSwitcherComponent,
  ],
  providers: [NgbActiveOffcanvas],
})
export class VerticalNavigationModule {}
